/**
 * 🧱 Refactor BT Phase 3 — section « SectionEquipementsCreer » de CreerBonTravailDialog.jsx : JSX déplacé TEL QUEL (ex-L1141-1205, dédenté de 10) ;
 * variables via `useBTForm()` (BTFormProvider enrichi par `extra`). DOM, data-testid, classes, textes inchangés.
 */
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useBTForm } from '../../BTFormContext';

export function SectionEquipementsCreer() {
  const {
    addEquipement,
    eqDisponibilite,
    equipements,
    form,
    isExt,
    removeEquipement,
    toggleEquipDate,
    type,
  } = useBTForm();
  return (
    <>
      {/* Équipements de chantier (extérieur seulement) */}
      {isExt && form.dates_chantier.length > 0 && (
        <Card className="border-amber-200">
          <CardHeader>
            <div className="flex justify-between items-center">
              <CardTitle className="text-base">Équipements de chantier</CardTitle>
              <Select onValueChange={(eqId) => {
                const dispo = eqDisponibilite[eqId];
                if (dispo && !dispo.disponible) {
                  toast.error(`Équipement indisponible: ${dispo.conflits[0]?.dossier_nom || 'autre contrat'}`);
                  return;
                }
                addEquipement(eqId);
              }}>
                <SelectTrigger className="w-48 h-8 text-xs"><SelectValue placeholder="+ Ajouter équipement" /></SelectTrigger>
                <SelectContent>
                  {equipements.filter(eq => !form.equipements_selectionnes.find(s => s.equipement_id === eq.id)).map(eq => {
                    const dispo = eqDisponibilite[eq.id];
                    const occupé = dispo && !dispo.disponible;
                    return (
                      <SelectItem key={eq.id} value={eq.id} disabled={occupé}>
                        <span className={`flex items-center gap-1.5 ${occupé ? 'opacity-40' : ''}`}>
                          {eq.emoji} {eq.nom}
                          {occupé && <span className="text-xs text-red-500 ml-1">(indisponible)</span>}
                        </span>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
            </div>
          </CardHeader>
          <CardContent>
            {form.equipements_selectionnes.length === 0 ? (
              <p className="text-center text-gray-400 py-3 text-sm">Aucun équipement sélectionné</p>
            ) : (
              <div className="space-y-3">
                {form.equipements_selectionnes.map((eq, eqIdx) => (
                  <div key={eqIdx} className="border rounded-lg p-3 bg-amber-50/30">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-medium text-sm">{eq.emoji} {eq.equipement_nom}</span>
                      <Button type="button" variant="ghost" size="sm" onClick={() => removeEquipement(eqIdx)}><Trash2 className="w-3.5 h-3.5 text-red-500" /></Button>
                    </div>
                    <p className="text-xs text-gray-500 mb-1">Sélectionnez les journées d'utilisation :</p>
                    <div className="flex flex-wrap gap-1">
                      {form.dates_chantier.map(d => {
                        const isUsed = eq.dates_utilisation.includes(d);
                        const dayLabel = new Date(d + 'T12:00:00').toLocaleDateString('fr-CA', { weekday: 'short', day: 'numeric', month: 'short' });
                        return (
                          <button key={d} type="button" onClick={() => toggleEquipDate(eqIdx, d)}
                            className={`px-2 py-1 rounded text-xs font-medium transition-colors ${isUsed ? 'bg-amber-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                            {dayLabel}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      )}


    </>
  );
}
